import React, { FC, memo, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { Modal } from 'app/design-system/components/Modal';

import { createAuthQuery } from '../../utils/auth-modals-query';
import { ModalContent } from '../ModalContent';

export const SigningDialog: FC = memo(() => {
  const { search } = useLocation();
  const history = useHistory();

  const handleClose = useCallback(() => {
    history.push('');
    sessionStorage.removeItem('phone');
  }, [search]);

  const isSign = search.startsWith(createAuthQuery('sign'));

  return (
    <Modal isOpen
           closable
           maxWidth={540}
           onClose={handleClose}
           isOutsideClickable={!isSign}
           data-test="Modal-Signing">
      <ModalContent />
    </Modal>
  );
});
